import React, { useEffect, useState } from 'react';
import { Card, Row, Col } from 'antd';
import { Link } from 'react-router-dom';

const SmartBuilderHome = () => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [settings, setSettings] = useState({});

    const fetchData = async () => {
        // Implementation of fetchData
    };

    const getSettings = async () => {
        // Implementation of getSettings
    };

    useEffect(() => {
        if (user) {
            setLoading(true);
            fetchData();
        }
    }, [user, fetchData]);

    useEffect(() => {
        if (user) {
            getSettings();
        }
    }, [user, getSettings]);

    return (
        <div style={{ padding: '24px' }}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <Link to="/smartbuild/orders">
                        <Card
                            title="SmartBuild Orders"
                            hoverable
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}
                            bodyStyle={{
                                padding: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '120px'
                            }}
                        >
                            <div style={{ textAlign: 'center' }}>
                                <p style={{ margin: 0, fontSize: '16px' }}>View New SmartBuild orders</p>
                                <p style={{ margin: '8px 0 0 0', color: '#1890ff', fontSize: '14px' }}>Click to view →</p>
                            </div>
                        </Card>
                    </Link>
                </Col>
                {/* <Col span={12}>
                    <Link to="/smartbuild/settings">
                        <Card
                            title="Settings"
                            hoverable
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}
                            bodyStyle={{
                                padding: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '120px'
                            }}
                        >
                            <div style={{ textAlign: 'center' }}>
                                <p style={{ margin: 0, fontSize: '16px' }}>Configure your SmartBuild credentials</p>
                                <p style={{ margin: '8px 0 0 0', color: '#1890ff', fontSize: '14px' }}>Click to view →</p>
                            </div>
                        </Card>
                    </Link>
                </Col> */}
                <Col span={12}>
                    <Link to="/smartbuild/myorders">
                        <Card
                            title="My Orders"
                            hoverable
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                            }}
                            bodyStyle={{
                                padding: '24px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minHeight: '120px'
                            }}
                        >
                            <div style={{ textAlign: 'center' }}>
                                <p style={{ margin: 0, fontSize: '16px' }}>View FCM orders</p>
                                <p style={{ margin: '8px 0 0 0', color: '#1890ff', fontSize: '14px' }}>Click to view →</p>
                            </div>
                        </Card>
                    </Link>
                </Col>
            </Row>
        </div>
    );
};

export default SmartBuilderHome; 